// This file provides utilities for Banner dimensions/layout in the current web stack.
// Kept minimal as it imports relevant values from the legacy/old-stack package.

import {
    BANNER_DIMENSIONS,
    FULL_COLUMN_WIDTH_FULL_SCREEN,
    BANNER_HEIGHT_DESKTOP_FULL_SCREEN,
} from '../modules/page-builder/config/column-constants';

type ItemType = 'project' | 'article';

interface Dimension {
    width: number;
    height: number;
}

const DIMENSION_MAP_MOBILE: Record<ItemType, Dimension> = {
    article: {
        width: 414,
        height: 336,
    },
    project: {
        width: 414,
        height: 378,
    },
};

const DIMENSION_MAP_DESKTOP: Record<ItemType, Dimension> = {
    article: BANNER_DIMENSIONS,
    project: {
        width: FULL_COLUMN_WIDTH_FULL_SCREEN,
        height: BANNER_HEIGHT_DESKTOP_FULL_SCREEN,
    },
};

export const getBannerDimensions = (itemType: ItemType) => {
    const mobileDimension = DIMENSION_MAP_MOBILE[itemType];
    const desktopDimension = DIMENSION_MAP_DESKTOP[itemType];
    return {
        ...{ ...BANNER_DIMENSIONS, ...desktopDimension },
        mobileWidth: mobileDimension.width,
        mobileHeight: mobileDimension.height,
    };
};
